import Thanx from './Thanx'

export default Thanx
